import { Blue80, Button } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';
import { Customer, Site } from '../../../../../../types';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { GcpOutlineIcon } from '../../../../../../images/components/GcpOutlineIcon';

const css = stylesheet({
  button: {
    marginTop: 12,
  },
});

interface Props {
  customer: Customer;
  site: Site;
}

export const GcpRequestButton = ({ customer, site }: Props) => {
  const handleClick = () => {
    trackAction('Click to "Requested GCP" button', { customer, site });
    window.open(GcpAppUrl + `/#/customers/${customer.id}/sites/${site.id}/current-gcp-request`);
  };

  return (
    <Button
      className={css.button}
      style="secondary"
      text="GCP Request"
      icon={<GcpOutlineIcon color={Blue80} />}
      fullWidth
      size="xs"
      onClick={handleClick}
    />
  );
};
